import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'task',
    serviceName: 'auth',
    query: gql`
      query task(
        $statuses: [String]
        $belongs_to_me: Int
      ) {
        task(
          statuses: $statuses
          belongs_to_me: $belongs_to_me
        ) {
          total
        }
      }
    `,
  },
};

export default schema;
